import { useSelector, useDispatch, connect } from 'react-redux';

export default function () {
    const userGroup = useSelector(state => state.authentication.user.group);
    const permissions = [
        {
            permission: 'MENU_DASHBOARD',
            groups: ['all'],
        },
        {
            permission: 'MENU_TEMPLATES',
            group: ['all']
        },
        {
            permission: 'MENU_TEMPLATES_LIST',
            group: ['all']
        },
        {
            permission: 'MENU_TEMPLATES_CREATE',
            group: ['superAdmin']
        },
        {
            permission: 'MENU_USERS',
            group: ['superAdmin']
        },
        {
            permission: 'MENU_USERS_LIST',
            group: ['superAdmin']
        },
    ]

    return [
        { "role": "operator", "resource": "user", "action": "read:own", "attributes": "*" },
        { "role": "operator", "resource": "user", "action": "update:own", "attributes": ["details.firstname", "details.lastname", "details.nationalId"] },
        { "role": "operator", "resource": "design", "action": "create:own", "attributes": ["name", "size.width", "size.height"] },
        { "role": "operator", "resource": "design", "action": "read:own", "attributes": "*" },
        { "role": "operator", "resource": "design", "action": "update:own", "attributes": "*" },
        { "role": "operator", "resource": "template", "action": "read:any", "attributes": "*" },
        { "role": "operator", "resource": "template", "action": "create:any", "attributes": "*" },
        { "role": "operator", "resource": "template", "action": "update:any", "attributes": ["name", "price", "description", "tags", "tagsFa"] },
        { "role": "operator", "resource": "resource", "action": "read:any", "attributes": "*" },
        { "role": "operator", "resource": "resource", "action": "update:any", "attributes": "*" },
        { "role": "operator", "resource": "resource", "action": "create:any", "attributes": "*" },
    ];

}